import React, { useState, useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import { useAuth } from './context/AuthContext';
import { useOMS } from './context/OMSContext';
import { Layout } from './components/Layout';
import { Loading } from './components/Loading';
import { Home } from './pages/Home';
import { Search } from './pages/Search';
import { Profile } from './pages/Profile';
import { MaintainAccess } from './pages/MaintainAccess';
import { VendorMaintenance } from './pages/VendorMaintenance';
import { EmployeeAccess } from './pages/EmployeeAccess';
import AttestationDisplay from './components/AttestationDisplay';
import { GlobalInbox } from './pages/GlobalInbox';
/*import { DemoOMS } from './pages/DemoOMS';*/
import { Resources } from './pages/Resources';
import { Admin } from './pages/Admin';
import { UnAuth } from './auth/UnAuth';
import { Privacy } from './pages/Privacy';
import { TermsOfUse } from './pages/TermsOfUse';
import { RemitAddresses } from './pages/RemitAddresses';
import { VendorWorklist } from './pages/VendorWorklist';
import { VendorBankRequest } from './pages/VendorBankRequest';
import { PageNotFound } from './pages/PageNotFound';
import 'bootstrap/dist/css/bootstrap.min.css';
import './custom.css';

const App = () => {
    //Performing Auth                
    const { authObj, login, logout, /*getUser*/ } = useAuth();
    const { omsObj, refreshWidget, /*disposeWidget*/ } = useOMS();
    const [currentCompanyId, setCurrentCompany] = useState(Number(sessionStorage.getItem("curSupName")));
    const [currentNotificationId, setCurrentNotificationId] = useState(Number(sessionStorage.getItem("curNotif")));
    /*const [performrefresh,setperformrefresh] = useState(false);*/
    const PerformLoginWrapper = ({ children }) => {
        useEffect(() => {
            login();
        }, []);
        return children;
    };

    const refreshApp = () => {
        authObj.authError = '';
        //Need a refresh or else site hangs
        //OLD
        //setPerformRefresh(true);
        // getUser();
        //refreshWidget();
        //Perform Refresh
        window.location.reload();
    }

    const updateCompanySelection = (companyId) => {
        setCurrentCompany(companyId);
    }

    const onNotificationAdded = (id) => {
        console.log(`Notification ID change occurred new id ${id}`);
        setCurrentNotificationId(id);
    }
    const hasAuthError = () => {
        let searchParams = new URLSearchParams(window.location.search);
        if (searchParams.has('AuthError')) {
            return searchParams.get('AuthError');
        }
        else { return ''; }
    }

    //Conditional Rendering
    if ((!authObj.isLoading && !authObj.getUserComplete) || (authObj.authError === '49C7B81B-E6A7-4E76-9121-ECE3E082DED4')) {
        login();
    }
    //No Attestation
    else if (!authObj.isLoading && authObj.getUserComplete && authObj.authError === 'B914D4D9-F87D-4240-B32C-F76ABC76E654') {
        return (
            <Layout isAuthenticated={false}>
                <AttestationDisplay showAttest={true} onLogout={logout} onAttest={refreshApp} />
            </Layout>
        );
    }
    //Error in Auth process
    else if ((authObj.getUserComplete && authObj.authError) || hasAuthError()) {


        return (
            <Layout isAuthenticated={false}>
                <UnAuth errorCode={(hasAuthError()) ? hasAuthError() : authObj.authError} user={authObj} />
            </Layout>
        );
    }
    else if (authObj.isAuthenticated && authObj.userObj) {
        //Authenticated
        // Set default value
        if (!currentCompanyId) {
            setCurrentCompany(Number(authObj.userObj.suppliers[0].supplierId));
        }

        return (
            <Layout isAuthenticated={true} currentUser={authObj.userObj} claims={authObj.claimsArr} currentCompanyId={currentCompanyId} currentNotificationId={currentNotificationId} onCompanyChange={updateCompanySelection} >
                <Routes>              
                    <Route exact path='/' element={(authObj.isAuthenticated) ? <Home currentUser={authObj.userObj} claims={authObj.claimsArr} currentCompanyId={currentCompanyId} /> : <PerformLoginWrapper><Home currentUser={authObj.userObj} claims={authObj.claimsArr} currentCompanyId={currentCompanyId} /></PerformLoginWrapper>} />
                    <Route path='/login' element={() => { login(); return null }} />
                    <Route path='/logout' element={() => { logout(); return null }} />
                    <Route path='/Search' element={<Search currentUser={authObj.userObj} claims={authObj.claimsArr} currentCompanyId={currentCompanyId} />} />
                    <Route path='/Profile' element={<Profile currentUser={authObj.userObj} claims={authObj.claimsArr} />} />
                    <Route path='/Profile/Supplier/Access' element={<MaintainAccess currentUser={authObj.userObj} claims={authObj.claimsArr} currentCompanyId={currentCompanyId} />} />
                    <Route path='/Profile/Employee/Access' element={<EmployeeAccess currentUser={authObj.userObj} claims={authObj.claimsArr} />} />
                    <Route path='/Resources' element={<Resources currentUser={authObj.userObj} claims={authObj.claimsArr} />} />
                    <Route path='/Admin' element={<Admin currentUser={authObj.userObj} currentCompanyId={currentCompanyId} claims={authObj.claimsArr} onNotificationAdded={onNotificationAdded} />} />
                   {/* <Route path='/Demo' element={<DemoOMS currentUser={authObj.userObj} currentCompanyId={currentCompanyId} claims={authObj.claimsArr} />} />*/}
                    <Route path='/Inbox' element={<GlobalInbox currentUser={authObj.userObj} currentCompanyId={currentCompanyId} claims={authObj.claimsArr} omsObj={omsObj} />} />
                    <Route path='/Privacy-Policy' element={<Privacy />} />
                    <Route path='/Terms-Of-Use' element={<TermsOfUse />} />
                    <Route path='/Admin' element={<Admin currentUser={authObj.userObj} />} />
                    <Route path='/Profile/Supplier' element={<VendorMaintenance currentUser={authObj.userObj} claims={authObj.claimsArr} currentCompanyId={currentCompanyId} />} />
                    <Route path='/Profile/Supplier/RemitAddresses' element={<RemitAddresses currentUser={authObj.userObj} claims={authObj.claimsArr} currentCompanyId={currentCompanyId} />} />
                    <Route path='/Worklist' element={<VendorWorklist currentUser={authObj.userObj} claims={authObj.claimsArr} currentCompanyId={currentCompanyId} />} />
                    <Route path='/Worklist/Request/:requestId' element={<VendorBankRequest currentUser={authObj.userObj} currentCompanyId={currentCompanyId} />} />
                    <Route path="*" element={<PageNotFound currentUser={authObj.userObj} currentCompanyId={currentCompanyId} />} />
                </Routes>
            </Layout>
        );
    }
    else {
        return (<Layout>
            <Loading />
        </Layout>);
    }
}

export default App;